import React from "react";
import { useSelector } from "react-redux";

// Remount private state (including pending details/media/tests) when the account changes.
export default function withFinancialSession(Component) {
  return function FinancialSession(props) {
    const user = useSelector(state => state.auth.user);
    const identity = JSON.stringify([user?.id ?? null, user?.email ?? null, user?.role ?? null]);
    return <Component key={identity} {...props} />;
  };
}
